/** Conversation-local bytes. Never interpreted as a server artifact or persisted in chat history. */
export class LocalDocumentStore {
    generate;
    files = new Map();
    jobs = new Map();
    epoch = 0;
    totalBytes = 0;
    taskId = `local-${crypto.randomUUID()}`;
    /**
     * `generate` is the entry's generator (assistantParts.ts): the full entry's loads the document writers the first time a
     * file is made, so this store never imports them itself and the web entry, which makes no files, never carries them.
     */
    constructor(generate) {
        this.generate = generate;
    }
    create(replyId, input) {
        const key = `${replyId}:${input.format}`;
        const existing = this.jobs.get(key);
        if (existing)
            return existing;
        const epoch = this.epoch;
        const job = (async () => {
            const result = await this.generate(input);
            if (epoch !== this.epoch)
                throw new Error('This conversation has closed. Create the file again in the current conversation.');
            if (!result.bytes.byteLength || result.bytes.byteLength > 8 * 1024 * 1024)
                throw new Error('This file exceeds the 8 MB document limit. Ask for a smaller document.');
            if (this.files.size >= 32 || this.totalBytes + result.bytes.byteLength > 32 * 1024 * 1024)
                throw new Error('This conversation has reached its file limit. Download your files and start a new conversation.');
            const artifact = { id: crypto.randomUUID(), taskId: this.taskId, name: result.name, mediaType: result.mediaType, sizeBytes: result.bytes.byteLength, source: 'desktop' };
            const bytes = new Uint8Array(result.bytes.byteLength);
            bytes.set(result.bytes);
            this.files.set(artifact.id, { artifact, blob: new Blob([bytes.buffer], { type: result.mediaType }), replyId });
            this.totalBytes += bytes.byteLength;
            return artifact;
        })();
        this.jobs.set(key, job);
        // Failures may be retried explicitly; successful output remains idempotent across UI remounts.
        void job.catch(() => { if (this.jobs.get(key) === job)
            this.jobs.delete(key); });
        return job;
    }
    resolve = (artifact) => {
        const entry = this.files.get(artifact.id);
        if (artifact.source !== 'desktop' || artifact.taskId !== this.taskId || !entry)
            throw new Error('This local file is no longer available. Use Export to create it again.');
        return entry.blob;
    };
    forReply(replyId) {
        return [...this.files.values()].filter(file => file.replyId === replyId).map(file => file.artifact);
    }
    clear() {
        this.epoch++;
        this.jobs.clear();
        this.files.clear();
        this.totalBytes = 0;
    }
}
//# sourceMappingURL=localDocuments.js.map